import {createElement, lazy} from 'react';

const routesConfig = [
    {
        path: '*',
        element: createElement(lazy(() => import(
            '^pages/error'
        )), {message: 'Page Not Found'}),
    },
    {
        path: '/login',
        element: createElement(lazy(() => import(
            '^pages/login',
        ))),
        authentication: true,
    },
    {
        path: '/logout',
        element: createElement(lazy(() => import(
            '^pages/logout',
        ))),
        authentication: true,
    },
    {
        path: '/facilities',
        element: createElement(lazy(() => import(
            '^pages/facility/facilityList',
        ))),
    },
    {
        path: '/users',
        element: createElement(lazy(() => import(
            '^pages/user/userList',
        ))),
    },
    {
        path: '/customers',
        element: createElement(lazy(() => import(
            '^pages/customer/customerList',
        ))),
    },
    {
        path: '/parts',
        element: createElement(lazy(() => import(
            '^pages/part/partList',
        ))),
    },
    {
        path: '/parts/:part_id/configs',
        element: createElement(lazy(() => import(
            '^pages/part/configList',
        ))),
    },
    {
        path: '/reports',
        element: createElement(lazy(() => import(
            '^pages/report/reportList',
        ))),
    },
    {
        path: '/reports/:type',
        element: createElement(lazy(() => import(
            '^pages/report/reportRun',
        ))),
    },
    {
        path: '/settings',
        element: createElement(lazy(() => import(
            '^pages/setting/settingList',
        ))),
    },
    {
        path: '/',
        element: createElement(lazy(() => import(
            '^pages/home/homeContainer',
        ))),
    },
    {
        path: '/resources',
        element: createElement(lazy(() => import(
            '^pages/resource/resourceList',
        ))),
    },
    {
        path: '/storage-locations',
        element: createElement(lazy(() => import(
            '^pages/storageLocation/storageLocationList',
        ))),
    },
    {
        path: '/staged-work-tickets',
        element: createElement(lazy(() => import(
            '^pages/stagedWorkTicket/stagedWorkTicketList',
        ))),
    },
    {
        path: '/work-tickets',
        element: createElement(lazy(() => import(
            '^pages/workTicket/workTicketList',
        ))),
    },
    {
        path: '/work-tickets/:work_ticket_id/bom',
        element: createElement(lazy(() => import(
            '^pages/workTicket/workTicketBOMList',
        ))),
    },
    {
        path: '/work-tickets/:work_ticket_id/:config_id/units',
        element: createElement(lazy(() => import(
            '^pages/workTicket/units/workTicketUnitsList',
        ))),
    },
    {
        path: '/work-tickets/:work_ticket_id/unit-overview',
        element: createElement(lazy(() => import(
            '^pages/workTicket/unitOverview/workTicketUnitOverview',
        ))),
    },
    {
        path: '/work-tickets/:work_ticket_id/kits',
        element: createElement(lazy(() => import(
            '^pages/workTicket/kitting/workTicketKitsList',
        ))),
    },
    {
        path: '/asset-capture',
        element: createElement(lazy(() => import(
            '^pages/assetCapture/assetCapture',
        ))),
    },
    {
        path: '/packing',
        element: createElement(lazy(() => import(
            '^pages/packing/packing',
        ))),
    },
    {
        path: '/manage-extensions',
        element: createElement(lazy(() => import(
            '^pages/extension/extensionList'
        )), {global: true}),
    },
    {
        path: '/manage-extensions/:extension_id',
        element: createElement(lazy(() => import(
            '^pages/extension/extensionEditCode',
        ))),
    },
    {
        path: '/extensions',
        element: createElement(lazy(() => import(
            '^pages/extension/extensionList'
        )), {global: false}),
    },
    {
        path: '/extensions/:extension_id',
        element: createElement(lazy(() => import(
            '^pages/extension/extensionLaunch',
        ))),
    },
];

export default routesConfig;
